/* @flow */

import * as types from './appNotificationActionTypes';

export function setBraindateNotificationCount(value: number): Object {
  return {
    type: types.SET_BRAINDATE_NOTIFICATION_COUNT,
    value,
  };
}

export function resetBraindateNotificationCount(): Object {
  return {
    type: types.RESET_BRAINDATE_NOTIFICATION_COUNT,
  };
}
